import React, { Component } from 'react';

class Unauth extends Component {
  render() {
    return (
      <div>
        <div className="splash-unauth">
        </div>
        <div className="splash-landing color-white">
          <h2 className="welcome animate hidden-default fade-in-up">
            Welcome to Polyg.io!
          </h2>
          <h3 className="font-large animate hidden-default fade-in-up one-s-delay">
            Log in or sign up to start learning!
          </h3>
          <div className="languages animate hidden-default fade-in-up">
            <a href="/choose-mode" className="language animate hidden-default fade-in-up">
              <img src="https://cdn0.iconfinder.com/data/icons/195-flat-flag-psd-icons/70/Mexico.png" />
              <h3>Spanish</h3>
            </a>
            <div className="language animate hidden-default fade-in-up">
              <img src="https://cdn0.iconfinder.com/data/icons/195-flat-flag-psd-icons/70/France.png" />
              <h3>French</h3>
            </div>
            <div className="language animate hidden-default fade-in-up">
              <img src="https://cdn0.iconfinder.com/data/icons/195-flat-flag-psd-icons/70/Germany.png" />
              <h3>German</h3>
            </div>
          </div>
        </div>
      </div>

    );
  }
}

export default Unauth;
